var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M17.826 7.238H17.1V7.2H9v3.6h5.086A5.398 5.398 0 0 1 3.6 9 5.4 5.4 0 0 1 9 3.6c1.377 0 2.63.52 3.583 1.368l2.546-2.546A8.959 8.959 0 0 0 9 0a9 9 0 1 0 8.826 7.238Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D00",
    d: "m1.037 4.81 2.957 2.17A5.398 5.398 0 0 1 9 3.6c1.376 0 2.629.52 3.582 1.367l2.546-2.545A8.959 8.959 0 0 0 9 0a8.995 8.995 0 0 0-7.963 4.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M9 18c2.325 0 4.437-.89 6.034-2.336l-2.786-2.357A5.36 5.36 0 0 1 9 14.4a5.398 5.398 0 0 1-5.078-3.576L.987 13.085A8.993 8.993 0 0 0 9 18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976D2",
    d: "M17.825 7.237H17.1V7.2H9v3.6h5.086a5.417 5.417 0 0 1-1.839 2.507h.002l2.785 2.356C14.837 15.843 18 13.5 18 9c0-.604-.062-1.193-.175-1.763Z"
  })));
};
export default SvgGoogle;